import React from 'react'

function Interests() {
  return (
    <div className='interest-section'>
        <div className="input-section">
        <h3>Interests</h3>
        <p className='interest-content'>Food expert. Music scholar. Reader. Internet fanatic. Bacon buff. Entrepreneur. Travel geek. Pop culture ninja. Coffee fanatic.</p>
        </div>
    </div>
  )
}

export default Interests